<ids-modal [open]="config.open" (openChange)="close()" width="600px">
  <ids-modal-header>
    <h2 idsModalTitle>{{ config.title }}</h2>
  </ids-modal-header>

  <ng-container *ngIf="!config.customComponent">
    <h2
      *ngIf="!config.subMessage; else withSubmessage"
      class="ids-insight -bold ids-my-8 ids-p-4"
    >
      {{ config.message }}
    </h2>

    <ng-template #withSubmessage>
      <div class="ids-px-4 ids-my-8">
        <h2 class="ids-insight -bold ids-mb-6">
          {{ config.message }}
        </h2>
        <span class="ids-subtitle -small">{{ config.subMessage }}</span>
      </div>
    </ng-template>

    <app-modal-footer
      [state]="config"
      (modalCancel)="onCancel()"
      (modalConfirm)="onConfirmAsync()"
    ></app-modal-footer>
  </ng-container>

  <app-dynamic-template
    *ngIf="config.customComponent"
    [component]="config.customComponent.component"
    [componentInputs]="config.customComponent.inputs"
  >
  </app-dynamic-template>
</ids-modal>
